import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SessionSotrageService } from "src/services/session-sotrage.service";

@Injectable({
  providedIn: "root",
})
export class StreamDownloadFetch {
  endpoint = environment.apiUrl + "PLD/administraciontransacciones/";
  endpointCasos = environment.apiUrl + "PLD/administracionCasos/";
  endpointPersonas = environment.apiUrl + "Personas/Persona/";

  searchProfile: string = "";

  constructor(private sssotrage: SessionSotrageService) {

  }

  async openBrowserWindowZip(fileName: string) {
    const handle = await (window as any).showSaveFilePicker({
      suggestedName: `${fileName}_${Date.now()}.zip`,
      types: [
        {
          description: "ZIP",
          accept: { "application/zip": [".zip"] },
        },
      ],
    });

    const writable = await handle.createWritable();
    return { handle, writable };
  }

  async Transacciones(payload: any, signal: AbortSignal): Promise<Response> {
    this.searchProfile = JSON.stringify(this.sssotrage.getPerfilBusqueda());
    this.searchProfile = this.searchProfile?.toString();
    const resp = await fetch(`${this.endpoint}streamDownloadTransacciones`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-profile": this.searchProfile,
      },
      body: JSON.stringify(payload),
      signal,
    });

    if (!resp.ok) {
      let msg = `HTTP ${resp.status}`;
      try {
        msg = await resp.text();
      } catch {}
      throw new Error(msg);
    }

    return resp;
  }

  async Casos(payload: any, signal: AbortSignal): Promise<Response> {
    this.searchProfile = JSON.stringify(this.sssotrage.getPerfilBusqueda());
    this.searchProfile = this.searchProfile?.toString();
    const resp = await fetch(`${this.endpointCasos}streamDownloadCasos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-profile": this.searchProfile,
      },
      body: JSON.stringify(payload),
      signal,
    });

    if (!resp.ok) {
      let msg = `HTTP ${resp.status}`;
      try {
        msg = await resp.text();
      } catch {}
      throw new Error(msg);
    }

    return resp;
  }

  async Personas(payload: any, signal: AbortSignal): Promise<Response> {
    this.searchProfile = JSON.stringify(this.sssotrage.getPerfilBusqueda());
    this.searchProfile = this.searchProfile?.toString();
    const resp = await fetch(`${this.endpointPersonas}streamDownloadPersonas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-profile": this.searchProfile,
      },
      body: JSON.stringify(payload),
      signal,
    });

    if (!resp.ok) {
      let msg = `HTTP ${resp.status}`;
      try {
        msg = await resp.text();
      } catch {}
      throw new Error(msg);
    }

    return resp;
  }
}
